<template>
  <div class="border border-slate-100 rounded-xl p-4 hover:border-slate-200 transition-colors">
    <!-- Route -->
    <div class="flex items-center gap-2 mb-2.5 min-w-0">
      <span class="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0"></span>
      <span class="text-sm font-semibold text-slate-800 truncate">{{ booking.startingLocation }}</span>
      <svg class="w-3.5 h-3.5 text-slate-300 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/>
      </svg>
      <span class="w-2 h-2 bg-emerald-500 rounded-full flex-shrink-0"></span>
      <span class="text-sm font-semibold text-slate-800 truncate">{{ booking.endingLocation }}</span>
    </div>

    <!-- Meta -->
    <div class="flex items-center gap-2 flex-wrap text-xs text-slate-500 mb-3">
      <span>{{ formatDate(booking.bookingDateTime) }}</span>
      <span class="text-slate-200">·</span>
      <span>{{ booking.cabType }}</span>
      <span class="text-slate-200">·</span>
      <span>{{ booking.numberOfPassengers }} passengers</span>
    </div>

    <!-- Badges -->
    <div class="flex items-center gap-2 flex-wrap">
      <span :class="['text-xs font-semibold px-2 py-0.5 rounded-full', statusClass]">
        {{ booking.status }}
      </span>
      <span :class="['text-xs font-semibold px-2 py-0.5 rounded-full', paymentClass]">
        {{ booking.paymentStatus }}
      </span>
    </div>
  </div>
</template>

<script>
const statusColors = {
  PENDING:   'bg-amber-50 text-amber-700',
  CONFIRMED: 'bg-blue-50 text-blue-700',
  COMPLETED: 'bg-emerald-50 text-emerald-700',
  CANCELLED: 'bg-red-50 text-red-700',
}

const paymentColors = {
  UNPAID:  'bg-red-50 text-red-600',
  PAID:    'bg-emerald-50 text-emerald-700',
  PENDING: 'bg-amber-50 text-amber-700',
}

export default {
  name: "BookingCard",

  props: {
    booking: { type: Object, required: true },
  },
  computed: {
    statusClass()  { return statusColors[this.booking.status]        || 'bg-slate-100 text-slate-600' },
    paymentClass() { return paymentColors[this.booking.paymentStatus] || 'bg-slate-100 text-slate-600' },
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleString();
    },
  },
};
</script>
